import { actionCreator } from 'utils';
import {
    ADD_NEW_IMPORT,
    LOAD_IMPORTS,
    SET_IMPORT_FILTER,
    SET_IMPORT_PAGINATION,
    RESET_IMPORT_FILTERS,
} from '../types/importTypes';

const initState = {
    loading: false,
    error: false,
    listing: null,
    offset: 0,
    limit: 10,
    filters: {
        file: '',
        status: undefined,
        created_by: [],
    },
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    add: {
        loading: null,
        error: false,
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case ADD_NEW_IMPORT:
        return Object.assign({}, state, {
            ...state,
            add: {
                ...state.add,
                loading: 'SENDING',
                error: false,
            },
        });

    case actionCreator(ADD_NEW_IMPORT, 'res'):
        return Object.assign({}, state, {
            ...state,
            add: {
                ...state.add,
                loading: action.loading,
            },
        });

    case actionCreator(ADD_NEW_IMPORT, 'err'):
        return Object.assign({}, state, {
            ...state,
            add: {
                ...state.add,
                error: true,
                loading: null,
            },
        });

    case LOAD_IMPORTS:
        return Object.assign({}, state, {
            loading: true,
            error: false,
        });

    case actionCreator(LOAD_IMPORTS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(LOAD_IMPORTS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case SET_IMPORT_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case SET_IMPORT_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case RESET_IMPORT_FILTERS:
        return Object.assign({}, state, {
            filters: initState.filters,
        });

    default:
        return state;
    }
}
